import React from 'react';
import { Route, Link } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import routes from '../../routes';

const findRouteName = url => routes[url];

const getPaths = (pathname) => {
  const paths = ['/'];

  if (pathname === '/') return paths;

  pathname.split('/').reduce((prev, curr) => {
    const currPath = `${prev}/${curr}`;
    paths.push(currPath);
    return currPath;
  });
  return paths;
};

const BreadcrumbsItem = ({ match }) => {
  const routeName = findRouteName(match.url);
  if (routeName) {
    return (
      match.isExact ?
        (
          <BreadcrumbItem active style={{ color: "#667eea", fontWeight: "600" }}>{routeName}</BreadcrumbItem>
        ) :
        (
          <BreadcrumbItem>
            <ol to={match.url || ''} style={{ color: "#764ba2", textDecoration: "none" }}>
              {routeName}
            </ol>
          </BreadcrumbItem>
        )
    );
  }
  return null;
};

const Breadcrumbs = ({ location: { pathname } }) => {
  const paths = getPaths(pathname);
  const items = paths.map((path, i) => <Route key={i++} path={path} component={BreadcrumbsItem} />);
  return (
    <Breadcrumb style={{
      background: "linear-gradient(135deg, #667eea08 0%, #764ba208 100%)",
      borderRadius: "10px",
      padding: "8px 15px",
      margin: "10px 0",
      border: "1px solid #667eea20",
      boxShadow: "0 2px 8px rgba(102, 126, 234, 0.06)"
    }}>
      {items}
    </Breadcrumb>
  );
};

export default props => (
  <div>
    <Route path="/:path" component={Breadcrumbs} {...props} />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Breadcrumb/Breadcrumb.js